import { baseUrl, isSignedIn, getHeaders, getMultipartHeaders } from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function GetRouterPreDefined() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/pre-routes`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetLauchPreFilled() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/launch/pre-filled-form`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PostLauchRouter(routeId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/${routeId}/launch`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function GetMainRouteEntities(mainRouteId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/${mainRouteId}/entities`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PostAssociateEgars(routeId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/${routeId}/associate-egars`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function DeleteAssociateEgar(routeId, egarId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/${routeId}/associate-egar/${egarId}/delete`;

    return axios.delete(urlApi, getHeaders(true));
}

export async function GetTransporterToRoute(routeId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/${routeId}/transporter`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetHistoryRoute(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/SILiAmb/routes/history${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetTranporterRouters() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/transporter/routes`;

    return axios.get(urlApi, getHeaders(true));
}

export async function RejectedEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/transporter/e-gar/rejected`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function CollectedEgar(egarId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/transporter/e-gar/${egarId}/collected`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function GetMainRoute() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/main-routes`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PostCreateRoute(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/sub-route`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function PutRouter(routeId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/${routeId}`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function GetTranporterGuideEgar(fileName) {
    await isSignedIn();
    const urlApi = `${baseUrl}/SILiAmb/transporter/download-egar/${fileName}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function DeleteEgarId(egarId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/egar/${egarId}/delete`;

    return axios.delete(urlApi, getHeaders(true));
}

export async function CompleteRouterById(routerId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/transporter/router/${routerId}/complete`;

    return axios.put(urlApi, "", getHeaders(true));
}
